import {IconProps} from "../icons";


export const ExportIcon = ({width, height, color}: IconProps) => {
  return (
    <svg className="icon" width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 20H19V18H5V20ZM19 9H15V3H9V9H5L12 16L19 9Z" fill={color}/>
    </svg>
  )
}